import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';

type CustomListItemTextProps = {
  primaryText: string;
  secondaryText: string;
};

export const CustomListItemText: React.FC<CustomListItemTextProps> = ({
  primaryText,
  secondaryText,
}) => {
  const theme = useTheme();

  return (
    <ListItemText
      primary={primaryText}
      secondary={secondaryText}
      primaryTypographyProps={{
        fontWeight: 600,
        fontSize: '0.95rem',
      }}
      secondaryTypographyProps={{
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
      }}
    />
  );
};
